import { PromotionType } from '../types/offers';
import formatModelName from './formatModelName';
import { priceFormat } from './formatPrice';

export const parseDigitalLeadsData = (
  offer: PromotionType,
  isCaMarket: boolean,
  confirmedZipcode?: string,
  dealerId?: string,
) => {
  const {
    customerDownPayment,
    monthlyPayment,
    term,
    aprRate,
    offerImageUrl,
    creditBonus,
    offerType,
    programShortDescription,
    cpoOffers,
  } = offer;

  const { modelYear, modelName, trimline, modelFamily, modelCodeDescription, vehicleType } =
    offer.offerModelDetail;

  const isUsedVehicle = vehicleType && vehicleType === 'USED-CAR';

  const correctType = !isCaMarket ? 'new' : vehicleType;

  const listOfUsedOffers = cpoOffers && Object.keys(cpoOffers);
  const usedBestOffer = listOfUsedOffers && listOfUsedOffers[0];

  const correctApr = () => {
    if (isCaMarket && !isUsedVehicle) return (aprRate / 100).toFixed(5);
    if (isCaMarket && isUsedVehicle && cpoOffers && usedBestOffer) return cpoOffers[usedBestOffer];
    return aprRate;
  };

  const normilizedModelName = isCaMarket ? modelName : formatModelName(modelCodeDescription);

  const dataInfo = {
    presetForm: 'contact-dealer',
    dealerId: dealerId ?? null,
    offers: {
      zip: confirmedZipcode ?? null,
      modelName: normilizedModelName ?? null,
      modelYear: modelYear ?? null,
      // we currently don't have trimName so we provide trimline
      trimName: trimline ?? null,
      image:
        offerImageUrl ??
        'https://nar.media.audi.com/is/image/audinar/nemo/us/offers/fallbacks/fallback_car_default.png',
      offerType: offerType ?? null,
      offerDetails: {
        customerDownPayment: customerDownPayment ?? null,
        term: term ?? null,
        monthlyPayment: monthlyPayment ? priceFormat(Number(monthlyPayment.toFixed())) : null,
        creditBonus: creditBonus ?? null,
        creditBonusDisclaimer: programShortDescription ?? null,
        aprRate: correctApr() ?? null,
        modelFamily: modelFamily ?? null,
        cpoTerm: usedBestOffer ?? null,
        type: correctType ?? null,
      },
    },
  };
  return JSON.stringify(dataInfo);
};
